import React from 'react';
import { Phone, AlertTriangle } from 'lucide-react';

export function EmergencyHelp() {
  return (
    <section className="py-8 px-12 bg-accessible-red-600">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <AlertTriangle className="w-[3em] h-[3em] text-white animate-pulse" aria-hidden="true" />
            <div>
              <h2 className="heading-3-white text-shadow-sm no-margin">
                Pomoc w nagłych przypadkach
              </h2>
              <p className="body-medium-white text-shadow-sm no-margin">
                Znalazłeś ranne lub zagubione zwierzę?
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Phone className="w-[2em] h-[2em] text-white animate-bounce" aria-hidden="true" />
            <div>
              <p className="body-small-white text-shadow-sm no-margin">Wyślij SMS, gdybyśmy nie mogli odebrać</p>
              <a href="tel:+48664821160" className="heading-3-white hover:text-yellow-300 transition-colors text-shadow-sm no-margin font-bold" aria-label="Zadzwoń na numer alarmowy: 664 821 160">664 821 160</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}